export default {
  authInitialized: false,
  isAuthenticated: false,
  candidateId: null,
  applications: [],
  applicationsLoading: false,
  applicationsLoaded: false,
  loadFailed: false,
  mustAcceptInvitations: false,
  profile: null,
  profileLoading: false,
  profileSaving: false,
  profileError: false
};
